"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectionList = exports.SelectionListItem = void 0;
const react_1 = __importStar(require("react"));
const SelectionListItem = ({ children, isSelected, onClick }) => {
    return (react_1.default.createElement("li", { className: `selection-list__item ${isSelected ? 'selection-list__item--selected' : ''}`, role: 'option', onClick: onClick, tabIndex: 0 },
        react_1.default.createElement("div", { className: "selection-list__item-button" }, children)));
};
exports.SelectionListItem = SelectionListItem;
const SelectionList = ({ children, onSelectCallback, defaultSelectedIndex, classes }) => {
    const listRef = (0, react_1.useRef)(null);
    const [selectedIndex, setSelectedIndex] = (0, react_1.useState)(typeof defaultSelectedIndex === 'number' && defaultSelectedIndex >= 0 && defaultSelectedIndex < react_1.default.Children.count(children)
        ? defaultSelectedIndex
        : null);
    (0, react_1.useEffect)(() => {
        const handleKeyDown = (event) => {
            if (listRef.current) {
                const focusableElements = Array.from(listRef.current.querySelectorAll('li'));
                const currentIndex = focusableElements.indexOf(document.activeElement);
                let nextIndex = currentIndex;
                switch (event.key) {
                    case 'ArrowDown': {
                        nextIndex = (currentIndex + 1) % focusableElements.length;
                        focusableElements[nextIndex].focus();
                        event.preventDefault();
                        break;
                    }
                    case 'ArrowUp': {
                        nextIndex = (currentIndex - 1 + focusableElements.length) % focusableElements.length;
                        focusableElements[nextIndex].focus();
                        event.preventDefault();
                        break;
                    }
                    case 'Enter':
                    case 'Space': {
                        const selectedIdx = selectedIndex === currentIndex ? null : currentIndex;
                        setSelectedIndex(selectedIdx);
                        onSelectCallback && onSelectCallback(event, selectedIdx);
                        event.preventDefault();
                        break;
                    }
                    default: {
                        return;
                    }
                }
            }
        };
        const listElement = listRef.current;
        listElement?.addEventListener('keydown', handleKeyDown);
        return () => {
            listElement?.removeEventListener('keydown', handleKeyDown);
        };
    }, [onSelectCallback, selectedIndex]);
    const handleSelect = (event, index) => {
        const selectedIdx = selectedIndex === index ? null : index;
        setSelectedIndex(selectedIdx);
        onSelectCallback && onSelectCallback(event, selectedIdx);
    };
    return (react_1.default.createElement("ul", { className: `selection-list ${classes ? classes : ''}`, ref: listRef, role: 'listbox', "aria-label": 'Selection list' }, react_1.default.Children.map(children, (child, index) => (react_1.default.createElement(exports.SelectionListItem, { onClick: (event) => handleSelect(event, index), isSelected: index === selectedIndex, children: child })))));
};
exports.SelectionList = SelectionList;
exports.default = exports.SelectionList;
